var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { TextField } from '../TextField';
import './AddressAutoCompleteOverride.scss';
var Interactions;
(function (Interactions) {
    Interactions["FIND"] = "Find";
    Interactions["RETRIEVE"] = "Retrieve";
})(Interactions || (Interactions = {}));
export var AddressAutoComplete = function (_a) {
    var dictionary = _a.dictionary, onSelectedAddress = _a.onSelectedAddress, postCanadaKey = _a.postCanadaKey;
    var _b = useState(null), value = _b[0], setValue = _b[1];
    var _c = useState(''), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    var getRequestUrl = function (interaction, value) {
        if (interaction === Interactions.RETRIEVE) {
            return "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Retrieve/v2.11/json3.ws?Key=" + encodeURIComponent(postCanadaKey) + "&Id=" + encodeURIComponent(value);
        }
        return "https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3.ws?Key=" + encodeURIComponent(postCanadaKey) + "&SearchTerm=" + encodeURIComponent(value) + "&SearchFor=" + encodeURIComponent('PostalCodes') + "&Country=" + encodeURIComponent('CAN') + "&MaxResults=" + encodeURIComponent(8);
    };
    var fetchData = function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var selectedAddressHandle = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var Id, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!address) return [3 /*break*/, 2];
                    Id = address.Id;
                    return [4 /*yield*/, fetchData(getRequestUrl(Interactions.RETRIEVE, Id))];
                case 1:
                    data = _a.sent();
                    if (data)
                        onSelectedAddress(data.Items[0]);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var isCanceled = false;
        if (isEmpty(inputValue) || inputValue.length <= 2) {
            return;
        }
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, newOptions, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchData(getRequestUrl(Interactions.FIND, inputValue))];
                    case 1:
                        data = _a.sent();
                        newOptions = [];
                        if (!isCanceled) {
                            if (data && !data.Items[0].Error) {
                                results = data.Items;
                                if (value) {
                                    newOptions = [value];
                                }
                                if (results) {
                                    newOptions = __spreadArray(__spreadArray([], newOptions), results);
                                }
                                setOptions(newOptions);
                            }
                            else {
                                //if error from API or no content empty options
                                setOptions([]);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            isCanceled = true;
        };
    }, [value, inputValue]);
    return (React.createElement(Autocomplete, { autoComplete: true, className: "custom-autocomplete", "data-testid": "autocomplete-search", getOptionLabel: function (option) { return (typeof option === 'string' ? option : option.Text + ", " + option.Description); }, id: "autocomplete-search", noOptionsText: dictionary.noOptions, onBlurCapture: function () {
            setOptions([]);
        }, onChange: function (event, newValue) {
            setOptions(newValue ? __spreadArray([newValue], options) : options);
            setValue(newValue);
            selectedAddressHandle(newValue);
        }, onInputChange: debounce(function (event, newInputValue) {
            setInputValue(newInputValue);
        }, 300), options: options.filter(function (option) { return option.Next !== Interactions.FIND; }), renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { fullWidth: true, label: dictionary.searchPlaceholder })); }, value: value }));
};
